import CommunityStonePath from './CommunityStonePath'

export default CommunityStonePath
